import { IMedia } from "@common/models/CMS";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import { Children, CSSProperties, FC } from "react";
import { useSelector } from "react-redux";


interface ICardProps {
    id?: string;
    className?: string;
    variant: 'horizontal' | 'vertical' | 'imageInText';
    cover?: IMedia;
    style?: CSSProperties;
    actionHover?: boolean;
    onClick?: (id?: string) => void;
    shadow?: boolean;
}

export const Card: FC<ICardProps> = ({ id, className = "", variant, children, style, actionHover, shadow, onClick }) => {
    const { large } = Config.get("viewport");
    const { width } = useSelector((state: IAppState) => ({ width: state.windowWidth }));

    return (
        <section
            id={id}
            className={`card card-${variant.toLowerCase()}${actionHover && width > large ? " action-hover" : ""}${shadow ? " shadow" : ""} ${className}`}
            onClick={() => { if (onClick) onClick(id) }} style={style}
        >
            {Children.toArray(children).find((child: any) => child.type?.displayName === "CardMedia")}
            <div className="card-wrapper">
                {Children.toArray(children).filter((child: any) => child.type?.displayName !== "CardMedia")}
            </div>
        </section>
    )
}
